import { useEffect, useState } from "react";
import { get } from "../../api";
import Footer from "../../Component/Footer";
import Header from "../../Component/Header";

const PrivacyPolicy = () => {
  const [pageData, setPageData] = useState<any>(null);
  useEffect(() => {
    getPagedata();
  }, []);

  // const getPagedata = async () => {
  //   const response = await get("/privacy-policy");
  //   setPageData(response?.data);
  // };

  const getPagedata = async () => {
    try {
      const response = await fetch(
        "https://www.darkroom.film/backend/api/v3/privacy-policy",
      );
      const data = await response.json();
      setPageData(data?.data);
    } catch (error) {
      // console.error("Error fetching about page data:", error);
    }
  };

  return (
    <>
      <Header />
      <main className="termservice_page">
        <div className="termservice_main">
          <section className="termservice-cont">
            <div className="container-fluid">
              <div className="innerpage_title">
                <span className="movititle-text">
                  <span>Privacy Policy</span>
                </span>
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: pageData?.page_content || "",
                }}
              ></p>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;

